module.exports = __webpack_public_path__ + "img/index3.57388dad.png";